import React from 'react';
import Seo from '@/components/Seo';
import { Quality as GlobalQuality } from '@/components/quality';
import { qualityContent } from '@/content/quality';

/**
 * Standalone "Quality" page, linked from the navbar's "Quality" entry
 * (see `siteConfig.pages`). Reuses the home page's "Quality" section
 * component as-is, so the content/markup stays in sync wherever it's
 * rendered — it is not removed from the home page (see `Home.tsx`), only
 * additionally reachable via this dedicated page.
 */
const Quality: React.FC = () => {
    return (
        <>
            <Seo title={qualityContent.sectionTitle} path="/quality" breadcrumbs={[]} />
            <GlobalQuality />
        </>
    );
};

export default Quality;
